import script from "./Recommend.vue?vue&type=script&setup=true&lang=ts"
export * from "./Recommend.vue?vue&type=script&setup=true&lang=ts"

import "./Recommend.vue?vue&type=style&index=0&id=06129aff&scoped=true&lang=css"

import exportComponent from "/deploy/src/necs_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06129aff"]])

export default __exports__